import React, { useState, useEffect, useContext } from "react";
import { useNavigate, Link, useSearchParams } from "react-router-dom";
import { Input } from "../Layout/Forms/Form";
import "./Login.css";
import Request from "../../api/Requests";
import { AuthContext } from "../../Context/AppContext";
import Loading from "../../components/Loading";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const LoginScreen = () => {
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { userInfo, setUserInfo } = useContext(AuthContext);
  const [showPassword, setShowPassword] = useState(false);
  const [form, setForm] = useState({
    email: "",
    password: "",
  });

  const [
    showAlerDefinirPasswordBussiness,
    setShowAlerDefinirPasswordBussiness,
  ] = useState(false);

  useEffect(() => {
    document.title = "Login | Nightspot";
    setIsLoading(false);
  }, []);

  useEffect(() => {
    if (userInfo && userInfo.firstName) {
      navigate(`/my/dashboard`);
    }
  }, [userInfo]);

  const handlerCheckAppUser = async () => {
    setIsLoading(true);
    let params = form;
    let response = await Request("site/login-check-isuser-app", "POST", params);
    if (response && response.status === true) {
      if (!response.data.isUserApp) {
        setShowPassword(true);
      } else {
        setShowAlerDefinirPasswordBussiness(true);
      }
    } else {
      toast.error(
        "Não encontramos o seu email registado, faça o registo primeiro.",
        {
          position: "top-left",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        },
      );
    }
    setIsLoading(false);
  };

  const handleLoginRequest = async (e) => {
    setIsLoading(true);
    e.preventDefault();
    let params = form;
    let response = await Request("site/login", "POST", params);

    if (response) {
      if (response.status === true) {
        setUserInfo({
          firstName: response.data.firstname,
          lastName: response.data.lastname,
        });
        localStorage.setItem("token-api", response.access_token);
        navigate(`/my/dashboard`);
      } else {
        toast.error(response.error, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      }
    }
    setIsLoading(false);
  };

  const handleChangeInputs = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  return isLoading ? (
    <Loading />
  ) : (
    <div className="signup-container d-flex justify-content-center align-items-center">
      <ToastContainer />
      <div className="signup-form-wrapper">
        <div className="text-center mb-4">
          <h1>Nightspot</h1>
          <h4>Bem-vindo de volta</h4>
        </div>

        <div
          className="alert alert-success"
          role="alert"
          style={{ display: searchParams.get("ref") ? "block" : "none" }}
        >
          O seu registo foi efetuado com êxito. Active a sua conta com a ligação
          que enviámos para o seu e-mail.
        </div>

        {showAlerDefinirPasswordBussiness && (
          <div className="alert alert-success text-center" role="alert">
            Defina uma password para a sua conta bussiness com a ligação que
            enviámos para o seu e-mail.
          </div>
        )}

        {!showAlerDefinirPasswordBussiness && (
          <form onSubmit={handleLoginRequest}>
            <div className="row">
              <div className="col-12">
                <div className="form-floating mb-3">
                  <Input
                    label="E-mail"
                    name="email"
                    value={form.email}
                    onChange={handleChangeInputs}
                    onPaste={(e) => {
                      e.preventDefault();
                      handleChangeInputs({
                        target: {
                          name: e.target.name,
                          value: e.clipboardData.getData("Text"),
                        },
                      });
                    }}
                    errors={form.errors}
                    placeholder="Escreva o seu email"
                  />
                </div>
              </div>
            </div>

            {showPassword && (
              <div className="row">
                <div className="col-12">
                  <div className="form-floating mb-3">
                    <Input
                      type="password"
                      label="Password"
                      name="password"
                      value={form.password}
                      onChange={handleChangeInputs}
                      onPaste={(e) => {
                        e.preventDefault();
                        handleChangeInputs({
                          target: {
                            name: e.target.name,
                            value: e.clipboardData.getData("Text"),
                          },
                        });
                      }}
                      errors={form.errors}
                      placeholder="Escreva a sua password"
                    />
                  </div>
                </div>
              </div>
            )}

            <div className="row mt-4">
              <div className="col-12 d-grid mx-auto text-center">
                <button
                  type={showPassword ? "submit" : "button"}
                  className="btn btn-primary btn-block"
                  onClick={!showPassword ? handlerCheckAppUser : undefined}
                >
                  {showPassword ? "LOGIN" : "SEGUINTE"}
                </button>
              </div>
            </div>
          </form>
        )}

        <div className="row mt-3">
          <div className="col-12 d-grid mx-auto text-center">
            <Link className="link-nostyle" to="/forgot-password">
              Recuperar password
            </Link>
          </div>
        </div>

        <hr className="grad-line" />

        <div className="row mt-3">
          <div className="col-12 d-grid mx-auto text-center">
            <span className="text-body-secondary">Não está registado? </span>
            <Link className="link-nostyle" to="/signup">
              Registar
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginScreen;
